import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-activation-page',
  templateUrl: './activation-page.component.html',
  styleUrls: ['./activation-page.component.css']
})
export class ActivationPageComponent implements OnInit {

  activationCode:String;
  constructor(private route: ActivatedRoute , private authService: AuthService) { }

  ngOnInit(): void {

  let activation = this.route.snapshot.paramMap.get('activationCode');
  this.activationCode=activation;
  console.log(this.activationCode)

  
  this.authService.VerifyUser(this.activationCode).subscribe(res => {
   console.log("Succes")}
   )};
;
  



  

}
